import React, { createContext, useContext, useState } from "react";

// Create the context
const RequestContext = createContext();

// Create a custom hook to use the context
export const useRequest = () => {
  return useContext(RequestContext);
};

// Create a provider component
export const RequestProvider = ({ children }) => {
  const [requestId, setRequestId] = useState(null);

  const updateRequestId = (newRequestId) => {
    setRequestId(newRequestId);
  };

  return (
    <RequestContext.Provider value={{ requestId, updateRequestId }}>
      {children}
    </RequestContext.Provider>
  );
};
